:host {
  pointer-events: auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  cursor: col-resize;
}

.divider {
  width: 1px;
  height: 100%;
  background-color: var(--neutral-300);
  cursor: col-resize;
}

.divider.highlighted {
  background-color: var(--blue-600);
}
